import { DelayedRequestState } from "csi/store/DelayedRequest";
import { useLocale } from "designSystem/locale";
import React, { FunctionComponent, Fragment, ReactElement, ReactNode } from "react";
import RichText from "designSystem/components/text/RichText";
import { Box, Text, OverflowText } from "designSystem/index";
import { grey, black } from "designSystem/styles/color";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { ButtonProps } from "designSystem/components/button/Button";
import { MIN_STRING_DROPDOWN_WIDTH } from "./InlinePopup";

const PREFIX = "DropdownPlaceholder";

const classes = {
	hint: `${PREFIX}hint`,
	label: `${PREFIX}label`,
};

export interface DropdownPlaceholderProps {
	actions?: ReactElement[];
	state: DelayedRequestState;
	onDialogClose: VoidFunction;
}
	
const DropdownPlaceholder: FunctionComponent<DropdownPlaceholderProps> = (props) => {
	const { actions, state, onDialogClose } = props;
	const loc = useLocale();
	let res = "";
	let searching = false;
	let results = false;

	switch (state) {
		case DelayedRequestState.WAITING:
			results = true;
			res = "TypeToSeeResults";
			break;
		case DelayedRequestState.SEARCHING:
			res = "Searching";
			searching = true;
			break;
		case DelayedRequestState.NO_RESULTS:
			res = "SEARCH_NO_RESULTS";
			break;
		case DelayedRequestState.RESULTS:
			results = true;
			break;
		default: return;
	}

	return (
		<Box>
			{res && (
				<Box
					alignItems="center"
					bgcolor={grey[100]}
					boxSizing="border-box"
					color={grey["A100"]}
					display="flex"
					flexDirection="column"
					flexGrow={1}
					height={150}
					justifyContent="center"
					minWidth={MIN_STRING_DROPDOWN_WIDTH}
					padding="0 16px"
				>
					<RichText value={loc.resource(res)} />
					<List role="listbox">
						{actions?.map((action: ReactElement<ButtonProps>, i: number): ReactNode => {
							let callClickEventOnMouseUp = false;
							function onPopperMouseDown(event: React.MouseEvent<HTMLButtonElement & HTMLLIElement>) {
								if (!(event.target as HTMLElement).children.length) {
									callClickEventOnMouseUp = true;
								}
								event.preventDefault();
							};
							function onPopperMouseUp(event: React.MouseEvent<HTMLButtonElement & HTMLLIElement>) {
								if (callClickEventOnMouseUp) {
									action.props.onClick?.(event);
									onDialogClose();
								}
							};
							return (
								<ListItem
									key={i}
									onMouseDown={onPopperMouseDown}
									onMouseUp={onPopperMouseUp}
								>
									{action}
								</ListItem>
							);
						})}
					</List>
				</Box>
			)}
			{(!results && !searching) && (
				<Box
					alignItems="center"
					bgcolor={grey[400]}
					boxSizing="border-box"
					color={black[100]}
					display="flex"
					height={26}
					padding="4px 8px"
					whiteSpace="nowrap"
				>
					<Text
						bold
						marginTop="1px"
						text={loc.resource("Hint")}
					/> : <OverflowText text={loc.resource("TypeEscapeToRevert")} />
				</Box>
			)}
		</Box>
	);
};

export default DropdownPlaceholder;
